import React from 'react';
import { View, Modal, Animated } from 'react-native';
import { PanGestureHandler, State } from 'react-native-gesture-handler';
import { useCssStyle } from '../../customHook/getCssStyle';
import FadeTransition from '../fadeTransition';
import SlideTransition from '../slideTransition';
import CustomPressable from '../customPressable/customPressable';
import FlashMessageComp from '../flashMessage/flashMessage';
import { useSelector } from 'react-redux';

export const CustomModal = ({ onRequestClose, children }) => {
    const getStyles = useCssStyle();
    const SWIPE_THRESHOLD = 150;
    const translateY = new Animated.Value(0);

    const { renderFlashMessage } = useSelector(state => state.appConfigSlice);

    const onGestureEvent = Animated.event(
        [{ nativeEvent: { translationY: translateY } }],
        {
            useNativeDriver: false,
            listener: ({ nativeEvent }) => {
                if (nativeEvent.translationY < 0) {
                    translateY.setValue(0);
                }
            },
        }
    );

    const onHandlerStateChange = ({ nativeEvent }) => {
        if (nativeEvent.state === State.END) {
            if (nativeEvent.translationY > SWIPE_THRESHOLD && onRequestClose) {
                onRequestClose();
            } else {
                Animated.spring(translateY, {
                    toValue: 0,
                    useNativeDriver: false,
                }).start();
            }
        }
    };

    return (
        <Modal visible={true} transparent statusBarTranslucent animationType="fade" onRequestClose={onRequestClose}>
            <View style={{ flex: 1 }}>

                {/* FlashMessage for modal - renders on top */}
                {renderFlashMessage.isVisible && <FlashMessageComp messageConfig={renderFlashMessage.messageConfig} />}

                {/* Backdrop with fade animation */}
                <CustomPressable
                    onPress={onRequestClose}
                    style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: "rgba(0,0,0,0.5)" }}
                />

                {/* Modal container positioned at bottom */}
                <View
                    style={getStyles(['customModalInnerContainer'])}
                    pointerEvents="box-none"
                >
                    {/* Modal Content with slide-up animation and swipe-down gesture */}
                    <SlideTransition duration={200} from={350}>
                        {onRequestClose ? (
                            <PanGestureHandler
                                onGestureEvent={onGestureEvent}
                                onHandlerStateChange={onHandlerStateChange}
                            >
                                <Animated.View
                                    style={{
                                        transform: [{ translateY }],
                                    }}
                                >
                                    {children}
                                </Animated.View>
                            </PanGestureHandler>
                        ) : (
                            <View>
                                {children}
                            </View>
                        )}
                    </SlideTransition>
                </View>
            </View>
        </Modal>
    );
};
